import { openBlock as o, createElementBlock as t, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return o(), t("svg", r, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M12 3c4.97 0 9 3.282 9 7.33 0 .411-.044.814-.124 1.206h.009c-.729 4.554-4.682 7.592-10.573 9.464.775-.807 1.755-2.045 2.439-3.368a11 11 0 0 1-.751.028c-4.97 0-9-3.282-9-7.33S7.03 3 12 3"
    }, null, -1)
  ])]);
}
const s = { render: l };
export {
  s as default,
  l as render
};
